(function () {
  'use strict';

  function messageFor(field) {
    if (field.validity.valueMissing) return 'Ce champ est obligatoire.';
    if (field.validity.customError) return field.validationMessage;
    if (field.validity.typeMismatch) return 'Saisissez une adresse email valide, par exemple nom@exemple.fr.';
    if (field.validity.tooShort) return 'Votre réponse est trop courte.';
    return 'Vérifiez cette information puis réessayez.';
  }

  function isPhoneField(field) {
    return field.dataset.domoxaPhoneField === 'true' || (field.type || '').toLowerCase() === 'tel';
  }

  function sanitisePhoneValue(field) {
    var value = field.value || '';
    var sanitised = value.replace(/[^0-9+().\s-]/g, '');
    var leadingWhitespace = (sanitised.match(/^\s*/) || [''])[0];
    var phoneBody = sanitised.slice(leadingWhitespace.length).replace(/\+/g, '');

    if (sanitised.slice(leadingWhitespace.length).charAt(0) === '+') {
      phoneBody = '+' + phoneBody;
    }
    sanitised = leadingWhitespace + phoneBody;

    if (sanitised !== value) field.value = sanitised;
    return sanitised.trim();
  }

  function phoneErrorFor(field) {
    if (!isPhoneField(field)) return '';

    var value = sanitisePhoneValue(field);
    if (!value) {
      field.setCustomValidity('');
      return '';
    }

    var normalised = value.replace(/[\s().-]/g, '');
    var isFrenchNumber = /^(?:0[67][0-9]{8}|\+33[1-9][0-9]{8})$/.test(normalised);
    var message = isFrenchNumber
      ? ''
      : 'Saisissez un numéro mobile français valide : 10 chiffres commençant par 06 ou 07, ou +33 suivi de 9 chiffres.';

    field.setCustomValidity(message);
    return message;
  }

  function track(form, eventName, field, index) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName.indexOf('domoxa_') === 0 ? eventName : 'domoxa_' + eventName,
      form_id: form.id || '',
      lead_segment: form.dataset.domoxaLeadSegment || '',
      form_page_path: window.location.pathname,
      form_variant: form.classList.contains('domoxa-lead-form--compact') ? 'compact' : 'detailed',
      field_name: field ? (field.name || '').replace(/^contact\[/i, '').replace(/\]$/, '') : '',
      field_index: typeof index === 'number' ? index + 1 : undefined
    });
  }

  function setError(field, message) {
    var id = field.id + '-error';
    var error = document.getElementById(id);
    if (!error) {
      error = document.createElement('p');
      error.className = 'domoxa-lead-form__error';
      error.id = id;
      error.setAttribute('role', 'alert');
      field.parentNode.appendChild(error);
    }
    error.textContent = message;
    field.setAttribute('aria-invalid', 'true');
    field.setAttribute('aria-describedby', id);
  }

  function clearError(field) {
    var error = document.getElementById(field.id + '-error');
    if (error) error.remove();
    field.removeAttribute('aria-invalid');
    field.removeAttribute('aria-describedby');
  }

  function validateField(field) {
    if (!field.willValidate) return true;
    var phoneError = phoneErrorFor(field);
    if (phoneError) {
      setError(field, phoneError);
      return false;
    }
    if (!field.checkValidity()) {
      setError(field, messageFor(field));
      return false;
    }
    clearError(field);
    return true;
  }

  function firstInvalidField(form, fields) {
    var firstInvalid = null;

    fields.forEach(function (field, index) {
      if (!validateField(field) && !firstInvalid) {
        firstInvalid = field;
        track(form, 'form_field_error', field, index);
      }
    });

    return firstInvalid;
  }

  function blockInvalidSubmission(event, form, fields) {
    var firstInvalid = firstInvalidField(form, fields);
    if (!firstInvalid) return false;

    event.preventDefault();
    event.stopImmediatePropagation();
    firstInvalid.focus();
    return true;
  }

  function fieldKey(field) {
    var name = (field.name || '').toLowerCase();
    if (/company|entreprise|société/.test(name)) return 'company';
    if (name.indexOf('email') !== -1) return 'email';
    if (/phone|tel|téléphone/.test(name)) return 'phone';
    if (/project|projet|type de projet/.test(name)) return 'project';
    if (/ville|city|location|address-level2/.test(name)) return 'location';
    if (/message|body|description/.test(name) || field.tagName.toLowerCase() === 'textarea') return 'message';
    if (/name|nom/.test(name)) return 'name';
    return 'extra';
  }

  function fieldWrapper(field) {
    return field.closest(
      '.domoxa-form-field, .domoxa-loxone__field, .landing-contact__field, .domoxa-contact-page__field, .ds-sec-form__field, .dp-form__field, .gtb-form__field, .field, [data-pf-type="Form2.Field"]'
    ) || field.parentElement;
  }

  function normaliseFieldSet(form) {
    var variant = form.classList.contains('domoxa-lead-form--compact') ? 'compact' : 'detailed';
    var desired = ['name', 'company', 'phone', 'email', 'project', 'location', 'message'];
    var fields = Array.prototype.slice.call(form.querySelectorAll('input:not([type="hidden"]), select, textarea'));
    var byKey = {};
    fields.forEach(function (field) {
      var key = fieldKey(field);
      if (!byKey[key]) byKey[key] = field;
    });

    var wrappers = [];
    desired.forEach(function (key) {
      var field = byKey[key];
      if (!field) return;
      var wrapper = fieldWrapper(field);
      if (wrappers.indexOf(wrapper) === -1) wrappers.push(wrapper);
      wrapper.classList.add('domoxa-lead-form__field');
      if (key === 'message') wrapper.classList.add('domoxa-lead-form__field--full');
    });

    fields.forEach(function (field) {
      var wrapper = fieldWrapper(field);
      if (desired.indexOf(fieldKey(field)) === -1) wrapper.hidden = true;
    });

    if (!wrappers.length) return;

    var parent = wrappers.length ? wrappers[0].parentElement : null;
    var sameParent = parent && wrappers.every(function (wrapper) { return wrapper.parentElement === parent; });
    var fieldsContainer = sameParent && parent !== form ? parent : document.createElement('div');

    if (fieldsContainer !== parent) {
      fieldsContainer.className = 'domoxa-lead-form__fields';
      var insertionPoint = wrappers[0];
      if (insertionPoint.parentElement !== form) {
        insertionPoint = form.querySelector('button[type="submit"], input[type="submit"]') || form.firstElementChild;
      }
      form.insertBefore(fieldsContainer, insertionPoint || null);
    } else {
      fieldsContainer.classList.add('domoxa-lead-form__fields');
    }

    wrappers.forEach(function (wrapper) { fieldsContainer.appendChild(wrapper); });
  }

  function setup(form) {
    if (form.dataset.domoxaLeadReady === 'true') return;
    form.dataset.domoxaLeadReady = 'true';
    if (!form.classList.contains('domoxa-lead-form')) {
      form.classList.add('domoxa-lead-form');
      var context = ((form.id || '') + ' ' + (form.className || '')).toLowerCase();
      form.classList.add(/hero|top|header/.test(context) ? 'domoxa-lead-form--compact' : 'domoxa-lead-form--detailed');
    }
    form.setAttribute('novalidate', 'novalidate');
    normaliseFieldSet(form);

    var fields = Array.prototype.slice.call(form.querySelectorAll('input:not([type="hidden"]), select, textarea'));
    fields.forEach(function (field, index) {
      field.addEventListener('focus', function () {
        if (!form.dataset.domoxaLeadStarted) {
          form.dataset.domoxaLeadStarted = 'true';
          track(form, 'form_start');
        }
      });
      field.addEventListener('blur', function () {
        if (!validateField(field)) track(form, 'form_field_error', field, index);
      });
      field.addEventListener('input', function () {
        if (isPhoneField(field)) sanitisePhoneValue(field);
        if (field.getAttribute('aria-invalid') === 'true') validateField(field);
      });
    });

    form.addEventListener('click', function (event) {
      var submitter = event.target.closest ? event.target.closest('button, input') : null;
      if (!submitter || submitter.form !== form || (submitter.type || '').toLowerCase() !== 'submit') return;

      if (!blockInvalidSubmission(event, form, fields)) {
        document.dispatchEvent(new CustomEvent('domoxa:lead-valid-submit', { detail: { form: form } }));
      }
    }, true);

    form.addEventListener('submit', function (event) {
      if (!blockInvalidSubmission(event, form, fields)) {
        document.dispatchEvent(new CustomEvent('domoxa:lead-valid-submit', { detail: { form: form } }));
      }
    }, true);
  }

  function init() {
    document.querySelectorAll('form').forEach(function (form) {
      var contactFields = Array.prototype.some.call(form.elements, function (field) {
        return /^contact\[/.test(field.name || '') && !/^(hidden|submit|button)$/i.test(field.type || '');
      });
      var tag = form.elements.namedItem('contact[tags]');
      if (contactFields && !(tag && tag.value === 'newsletter')) setup(form);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
